import type { Incident } from '../lib/types';

interface Props {
  incident: Incident;
}

function formatWindow(start: string | null, end: string | null): string {
  if (!start) return 'Scheduled';
  const opts: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
  };
  const s = new Date(start).toLocaleString(undefined, opts);
  if (!end) return s;
  const e = new Date(end).toLocaleString(undefined, opts);
  return `${s} -- ${e}`;
}

export function ScheduledNotice({ incident }: Readonly<Props>) {
  return (
    <div className="rounded-md border border-status-maintenance/40 bg-status-maintenance/10 px-4 py-3 text-[var(--color-fg)]">
      <div className="font-mono text-xs uppercase tracking-wider text-status-maintenance">
        Scheduled maintenance
      </div>
      <div className="font-display mt-0.5 font-medium">{incident.title}</div>
      <div className="mt-1 text-sm text-[var(--color-fg-muted)]">
        {formatWindow(incident.scheduledFor, incident.scheduledUntil)}
      </div>
    </div>
  );
}
